import type { TypographyProps } from '@mui/material/Typography';
import React from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

interface LabelProps extends TypographyProps<'label'> {
  isRequired?: boolean;
  isError?: boolean;
}

const LabelRoot = styled((props: TypographyProps<'label'>) => <Typography {...props} component="label" />, {
  label: 'Label',
})(({ theme }) => ({
  fontSize: '16px',
  lineHeight: '18px',
  fontWeight: 700,
  marginBottom: '4px',
  display: 'flex',
  span: {
    fontSize: '12px',
    marginLeft: '4px',
    '&.error': {
      color: theme.palette.error.main,
    },
  },
}));

const Label: React.FC<LabelProps> = ({ children, isRequired = false, isError = false, ...props }) => {
  return (
    <LabelRoot {...props}>
      {isRequired && <span className={isError ? 'error' : ''}>*</span>}
      {children}
    </LabelRoot>
  );
};

export default Label;
